export default "__VITE_ASSET__DRj2wgNF__"